<div class="qr-redirect-container">
  <div class="loading-content" *ngIf="isAttemptingAppOpen">
    <div class="spinner"></div>
    <p>Opening Jujuja App...</p>
    <p class="subtitle">If the app doesn't open, options will appear below</p>
  </div>
  <div class="fallback-content" *ngIf="!isAttemptingAppOpen && isMobileDevice">
    <div class="app-not-found">
      <h2>App Not Found</h2>
      <p>It looks like the Jujuja app is not installed on your device.</p>
      <div class="actions">
        <button class="btn-download" (click)="downloadApp()">Download App</button>
        <button class="btn-checkin" (click)="goToCheckin()">Continue to Check-In</button>
      </div>
    </div>
  </div>
  <div class="fallback-content" *ngIf="!isAttemptingAppOpen && !isMobileDevice">
    <div class="desktop-message">
      <h2>Mobile App Required</h2>
      <p>Please scan this QR code with a mobile device to open the Jujuja app.</p>
      <button class="btn-checkin" (click)="goToCheckin()">Continue to Check-In Website</button>
    </div>
  </div>
</div>

